import { component } from 'picoapp'
import { zelektor, loopify } from '@/lib/utility-functions.js'

export default component((node,ctx) => {
    /*******************************************************************************************************************************************/
    /* Data + Elements
    /*******************************************************************************************************************************************/
    const { navItem: navItems = [], contentItem: contentItems = [] } = zelektor(node)


    /*******************************************************************************************************************************************/
    /* Event Listeners
    /*******************************************************************************************************************************************/
    loopify(navItems).forEach(n => {
        n.addEventListener('click', clickNavItem)
    })

    loopify(contentItems).forEach(c => {
        const { title } = zelektor(c)
        title.addEventListener('click', clickItemTitle)
    })

    window.addEventListener('resize', () => {
        if (window.innerWidth > 1024) loopify(navItems)[0].click()
    })


    /*******************************************************************************************************************************************/
    /* Init
    /*******************************************************************************************************************************************/
    init()

    function init() {
        if (window.innerWidth > 1024 && loopify(navItems).length && loopify(contentItems).length) {
            const item = loopify(navItems)[0]
            item.click()
        }
    }


    /*******************************************************************************************************************************************/
    /* Functions
    /*******************************************************************************************************************************************/
    function clickNavItem(e) {
        const thisItem = e.currentTarget
        const { index } = thisItem.dataset

        loopify(navItems).forEach(i => {
            i === thisItem
            ? i.classList.add('is-active')
            : i.classList.remove('is-active')
        })
        
        loopify(contentItems).forEach(i => {
            i.dataset.index === index
            ? i.classList.add('is-active')
            : i.classList.remove('is-active')
        })
    }

    function clickItemTitle(e) {
        const thisTitle = e.currentTarget
        const contentItem = thisTitle.parentElement
        
        contentItem.classList.toggle('is-active')
    }
})